import { message } from "antd";

export default class CustomUploadAdapter {
  loader: any;

  constructor(loader: any) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then((file: File) => {
      // Validate file type
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validTypes.includes(file.type)) {
        //message.error("Unsupported file type. Please upload a png or jpg file.");
        return Promise.reject("Unsupported file type. Please upload a png or jpg file.");
      }

      // Validate file size (max 50MB)
      const maxSize = 50 * 1024 * 1024;
      if (file.size > maxSize) {
        //message.error("File size should be less than 50MB.");
        return Promise.reject("File size should be less than 50MB.");
      }

      // ✅ Initialize arrays if they don't exist
      if (!(window as any).pendingContestImages) {
        (window as any).pendingContestImages = [];
      }
      if (!(window as any).blobUrlMappings) {
        (window as any).blobUrlMappings = [];
      }
      if (!(window as any).serverImages) {
        (window as any).serverImages = [];
      }

      // ✅ Get current editor content to validate actual images present
      const currentEditorContent = (window as any).currentEditorContent || "";

      const pendingImages: File[] = (window as any).pendingContestImages;
      const serverImages = (window as any).serverImages || [];

      // ✅ Filter only images that are ACTUALLY in the editor
      const activeServerImages = serverImages.filter((img: any) =>
        currentEditorContent.includes(img.fileUrl)
      );
      // ✅ VALIDATION 1: Maximum 20 images (server + pending + current)
      const totalImageCount = serverImages.length + pendingImages.length;
      if (totalImageCount >= 20) {
        //message.error("You can upload a maximum of 20 images.");
        return Promise.reject("Maximum 20 images allowed.");
      }

      const activePendingImages = pendingImages.filter((file: File, index: number) => {
        const mapping = (window as any).blobUrlMappings[index];
        return mapping && currentEditorContent.includes(mapping.blobUrl);
      });

      // console.log('Validation check:', {
      //   totalServerImages: serverImages.length,
      //   activeServerImages: activeServerImages.length,
      //   totalPendingImages: pendingImages.length,
      //   activePendingImages: activePendingImages.length
      // });

      // ✅ VALIDATION 2: Total combined size must not exceed 50MB
      const serverSize = serverImages.reduce((acc: number, img: any) => acc + (img.fileSize || 0), 0);
      const pendingSize = pendingImages.reduce((acc: number, f: File) => acc + f.size, 0);
      const totalSize = serverSize + pendingSize + file.size;
      const maxTotalSize = 50 * 1024 * 1024; // 50MB

      if (totalSize > maxTotalSize) {
        const currentSizeMB = ((serverSize + pendingSize) / (1024 * 1024)).toFixed(2);
        const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
        // message.error(
        //   `Total size limit exceeded! Current: ${currentSizeMB}MB + New file: ${fileSizeMB}MB. Maximum total size is 50MB.`
        // );
        return Promise.reject("Maximum allowed image size is 50 MB.");
      }

      // ✅ Create blob URL
      const blobUrl = URL.createObjectURL(file);


      // ✅ Check if this file is already pending (avoid duplicates)
      const existingIndex = (window as any).pendingContestImages.findIndex(
        (f: File) => f.name === file.name && f.size === file.size && f.lastModified === file.lastModified
      );

      if (existingIndex === -1) {
        // ✅ New file - add to pending
        (window as any).pendingContestImages.push(file);
        (window as any).blobUrlMappings.push({
          blobUrl: blobUrl,
          fileName: file.name,
          file: file,
          timestamp: Date.now() // Track when it was added
        });

        // console.log('✓ New image added:', file.name, 'Blob URL:', blobUrl);
        // console.log('Total pending images:', (window as any).pendingContestImages.length);
      } else {
        console.log('Image already in pending queue:', file.name);
      }

      // ✅ Return blob URL for CKEditor preview
      return { default: blobUrl };
    });
  }

  abort() {
    console.log('Upload aborted');
  }
}